import { useCallback } from 'react';
import { OrgType } from '@retail/auth/types';
import { OrgUnitType } from '@retail/mgpris/config-types';
import { AppMessageKeys, useAppTFunction } from '@retail/app/i18n';

const labelKeys: Record<OrgType, AppMessageKeys> = {
  RETAIL_BRAND: 'app.orgUnit.type.RETAIL_BRAND',
  RETAIL_DATAOWNER: 'app.orgUnit.type.RETAIL_DATAOWNER',
  RETAIL_LOCATION: 'app.orgUnit.type.RETAIL_LOCATION',
  RETAIL_LOCATION_LIGHT: 'app.orgUnit.type.RETAIL_LOCATION_LIGHT',
  RETAIL_LOCATION_LIGHT_PLUS: 'app.orgUnit.type.RETAIL_LOCATION_LIGHT_PLUS',
  RETAIL_LOCATION_UNDER_MASTER: 'app.orgUnit.type.RETAIL_LOCATION_UNDER_MASTER',
  WHOLESALE_BRAND: 'app.orgUnit.type.WHOLESALE_BRAND',
  WHOLESALE_LOCATION: 'app.orgUnit.type.WHOLESALE_LOCATION',
  WHOLESALE_PRICE_LIST: 'app.orgUnit.type.WHOLESALE_PRICE_LIST',
};

export const useOrgUnitTypeLabel = () => {
  const t = useAppTFunction();
  return useCallback(
    (orgUnitType: OrgUnitType) => t(labelKeys[OrgUnitType.fromOrgUnitType(orgUnitType)]),
    [t]
  );
};
